import React from 'react'

const Loading = () => {
  return (
    <div className="container">
    <span className="loader_user"></span> 
    
  </div>
  )
}

export default Loading